var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenu = function SvgMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none",
    viewBox: "0 0 36 36"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#001923",
    fillRule: "evenodd",
    d: "M33.75 20.25H2.25v-4.5h31.5zM33.75 11.25H2.25v-4.5h31.5zM33.75 29.25H2.25v-4.5h31.5z",
    clipRule: "evenodd"
  })));
};
export default SvgMenu;